import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Nav from "react-bootstrap/Nav";
import { FaMessage } from "react-icons/fa6";
import { IoIosCall } from "react-icons/io";
import { RiFacebookCircleFill } from "react-icons/ri";
import { FaWhatsappSquare } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const Header = () => {
  return (
    <div>
      <>
        <Nav
          className="justify-content-center bg-dark text-light py-2 fs-6 px-5"
          activeKey=""
        >
          <Nav.Item className="ps-md-5">
            <Nav.Link href="/FAQ" className="text-white">
              FAQ
            </Nav.Link>
          </Nav.Item>
          <div className="vr" />
          <Nav.Item>
            <Nav.Link eventKey="/Rules" href="/Rules" className="text-white">
              Rules
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="link-2" href="/Notices" className="text-white">
              Notices
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="link-2"
              href="/Activities"
              className="text-white"
            >
              Activities
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="link-2" className="text-white">
              <IoIosCall className="fs-4 pb-1" /> 07533881186
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="disabled" className="text-white" disabled>
              <MdEmail className="fs-4 pb-1" /> barassociationd.dun@gmail.com
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className=" ms-md-auto">
            <Nav.Link
              href="https://www.facebook.com/p/%E0%A4%B5%E0%A4%BF%E0%A4%A7%E0%A4%BF-%E0%A4%AD%E0%A4%B5%E0%A4%A8-%E0%A4%A6%E0%A5%87%E0%A4%B9%E0%A4%B0%E0%A4%BE%E0%A4%A6%E0%A5%82%E0%A4%A8-100083055402675/?locale=cs_CZ&_rdr"
              className="text-white"
              target="_blank"
            >
              <RiFacebookCircleFill className="fs-4 text-primary bg-white rounded-circle" />
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="pe-md-5">
            <Nav.Link
              href="https://api.whatsapp.com/send?phone=917533881186"
              className="text-white "
              target="_blank"
            >
              <FaWhatsappSquare className="fs-4 text-success bg-white rounded" />
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </>
    </div>
  );
};

export default Header;
